var tables = [
    { // 0 tab1
        color: 'green',
        title:'Dette er fordelene det gir deg:',
        data: [
            {
                title: 'Bedre stressmestring',
                text: 'Du håndterer stress bedre enn personer som drikker mye; alkohol ødelegger nemlig stressystemet vårt på lang sikt.'
            },
            {
                title: 'Unngå alvorlige konsekvenser',
                text: 'Å drikke mye kan føre til høyt blodtrykk, hjertearytmi, hjerteforstørrelse og hjerneblødning. Det slipper du.'
            },
            {
                title: 'Mer stabil psykisk helse',
                text: 'Når man drikker mye, blir risikoen for angst og depresjon større. Depresjon er to til fire ganger vanligere hos personer som drikker mye alkohol, enn hos dem som drikker slik som deg.'
            },
            {
                title: 'Mer opplagt',
                text: 'Alkohol sluker energi og gir økt stress. Så sammenlignet med dem som drikker mer, har du mye energi til å gjøre andre ting!'
            },
            {
                title: 'Bedre søvn',
                text: 'Når du har drukket, er det kanskje lettere å sovne, men kvaliteten på søvnen blir dårligere. Alkohol påvirker hvor dypt du sover, og det er en viss risiko for at du ikke er uthvilt når du våkner. Du som sovner edru, sover best!'
            },
            {
                title: 'Ditt smarteste jeg',
                text: 'Du konsentrerer deg bedre og blir mer kreativ uten alkohol. Når du drikker, fungerer hjernen dårligere; både det intellektuelle arbeidet, hukommelsen, de skapende funksjonene og selve tenkingen påvirkes negativt. Du er ditt smarteste jeg når du ikke drikker.'
            },
            {
                title: 'Ingen dagen-derpå-angst',
                text: 'Når du drikker så lite som det du gjør, slipper du å være redd for alt som kan skje når man drikker for mye: misforståelser, krangler, vold og ulykker som oppstår fordi alkohol svekker både vurderingsevnen og konsekvenstenkingen. Det slipper du!'
            },
            {
                title: 'Trening som gir effekt',
                text: `På tide å svette litt? Du som ikke drikker for mye, har alle forutsetninger for å ha en god treningsøkt.
            Å trene styrke like før du skal drikke, eller dagen etter at du har drukket mye, er nesten bortkastet, for alkoholen avbryter prosessen som bygger opp musklene. Men det gjelder ikke deg!`
            },
            {
                title: 'Spar penger',
                text: 'Alkohol er dyrt. Mange som drikker mye, blir forbauset over hvor stor del av utgiftene som går til alkohol. Du kan bruke pengene dine på andre ting.'
            },
            {
                title: 'Sunn glød',
                text: 'Alkohol påvirker kroppen på mange forskjellige måter. Blant annet får man dårligere hud når man drikker mye. Man kan få utslett, huden blir tørr, og man ser blek og dradd ut. Men ikke du!'
            },

        ]
    },
    { // 1 tab2 // jobber annet
        color: 'orange',
        title: 'Slik kan du drikke mindre når du drikker som mest:',
        data: [
            {
                title:'Unngå runder',
                text:`
                Det høres kanskje hyggelig ut å spandere en runde hver, men det er en dårlig idé når du
                prøver å ha kontroll på hvor mye du drikker. Må du spandere? Kjøp noe alkoholfritt til deg
                selv. Har noen allerede tatt den første runden? Vipps penger til den som har gått for å
                bestille, så kan du droppe å være med på de neste rundene.`
                },
                {
                title:'Annenhver hvit',
                text:`
                Annethvert glass med vann kan være vanskelig å gjennomføre hvis det sosiale
                drikkepresset er sterkt. Sats på å ta annethvert glass med noe alkoholfritt, så er det
                mindre påfallende. Etter en gin & tonic tar du en tonic, etter en øl tar du en alkoholfri øl.
                Ingen kommer til å se forskjell, og du slipper unna kommentarene.`
                },
                {
                title:'Spis først',
                text:`
                Spis godt. Sørg for at du aldri drikker på tom mage. Spis gjerne middag før du drikker.
                Maten beskytter magen mot irritasjon og bidrar til at alkoholen ikke tas opp i blodet like
                fort.`
                },
                {
                title:'La glasset hvile',
                text:`
                Mange ganger går armen til munnen helt automatisk. Kanskje står du med glasset i
                hånden hele tiden fordi det er godt å ha noe å holde i?
                Drikk saktere ved å sette fra deg glasset etter hver slurk.`
                },
                {
                title:'Lavere alkoholinnhold',
                text:`
                Velg et svakere alternativ. Be om en snillere drink. Ta en lettøl. Velg vin med lavere
                alkoholinnhold.
                Jo langsommere du får i deg alkoholen, desto bedre.`
                },
                {
                title:'Ikke si “nja …”',
                text:`
                Forskning viser at det har god effekt å begynne setningen med et nei når du vil avstå fra
                alkohol.
                Når du er tydelig fra starten av, er risikoen for å vakle mindre, og den som spør, får mindre
                rom for å prøve å overtale deg.
                “Nei, jeg står over. Hvordan går det med fotballen, spilte ikke dere kamp forrige uke?”`
                },
                {
                title:'Jug i vei!',
                text:`
                Selv om du prøver å redusere alkoholinntaket, er det ikke sikkert at du har lyst til å snakke
                om det hele tiden. Med noe alkoholfritt i glasset skiller du deg ikke ut, og forhåpentligvis
                unngår du diskusjoner og mas. Det kan være godt å ha noe i hånden, og da kan du også
                være med når det skal skåles, men ingen trenger å få vite at det ikke er alkohol du drikker.`
                },
                {
                title:'Gjør noe',
                text:`
                Når man bare sitter og snakker, drikker man ofte mer. Gjør noe! Spill biljard, dans, ha en
                quiz – beveg deg, rett og slett. Det øker kanskje ikke forbrenningen, men så lenge du er
                opptatt med noe, drikker du mindre.`
                },
        ]
    },
    { // 1 tab3 // pensjonist
        color: 'orange',
        title: 'Slik kan du drikke mindre når du drikker som mest:',
        data: [
            {
                title:'Dropp kartong',
                text:`
                Det er mye vanskeligere å holde oversikt over hvor mye du du har drukket når du drikker
                vin fra kartong. Det er også veldig mye lettere å bare ta seg et lite glass til – og så ett til og
                enda et lite glass – noe som du kanskje hadde hoppet over om du hadde vært nødt til å
                åpne en helt ny flaske.`,
                },
                {
                title:'Unngå runder',
                text:`
                Det høres kanskje hyggelig ut å spandere en runde hver, men det er en dårlig idé når du
                prøver å ha kontroll på hvor mye du drikker. Må du spandere? Kjøp noe alkoholfritt til deg
                selv. Har noen allerede tatt den første runden? Vipps penger til den som har gått for å
                bestille, så kan du droppe å være med på de neste rundene.`,
                },
                {
                title:'Annenhver hvit',
                text:`
                Annethvert glass med vann kan være vanskelig å gjennomføre hvis det sosiale
                drikkepresset er sterkt. Sats på å ta annethvert glass med noe alkoholfritt, så er det
                mindre påfallende. Etter en kaffe & baileys tar du en kaffe, etter en øl tar du en alkoholfri
                øl. Ingen kommer til å se forskjell, og du slipper unna kommentarene.`,
                },
                {
                title:'Spis først',
                text:`
                Spis godt. Sørg for at du aldri drikker på tom mage. Spis gjerne middag før du drikker.
                Maten beskytter magen mot irritasjon og bidrar til at alkoholen ikke tas opp i blodet like
                fort.`,
                },
                {
                title:'La glasset hvile',
                text:`
                Mange ganger går hånden til munnen helt automatisk. Kanskje har du glasset i hånden
                hele tiden fordi det er godt å ha noe å holde i?
                Drikk saktere ved å sette fra deg glasset etter hver slurk.`,
                },
                {
                title:'Lavere alkoholinnhold',
                text:`
                Velg et svakere alternativ. Ta en lettøl. Velg vin med lavere alkoholinnhold.
                Jo langsommere du får i deg alkoholen, desto bedre. Kroppen tåler også alkohol dårligere
                med økende alder.`,
                },
                {
                title:'Ikke si “nja …”',
                text:`
                Forskning viser at det har god effekt å begynne setningen med et nei når du vil avstå fra
                alkohol.
                Når du er tydelig fra starten av, er risikoen for å vakle mindre, og den som spør, får mindre
                rom for å prøve å overtale deg.
                “Nei, jeg står over. Hvordan går det med fotballen, spilte ikke dere kamp forrige uke?”`,
                },
                {
                title:'Jug i vei!',
                text:`
                Selv om du prøver å redusere alkoholinntaket, er det ikke sikkert at du har lyst til å snakke
                om det hele tiden. Med noe alkoholfritt i glasset skiller du deg ikke ut, og forhåpentligvis
                unngår du diskusjoner og mas. Det kan være godt å ha noe i hånden, og da kan du også
                være med når det skal skåles, men ingen trenger å få vite at det ikke er alkohol du drikker.`,
                },
                {
                title:'Gjør noe',
                text:`
                Når man bare sitter og snakker, drikker man ofte mer. Gjør noe! Spill et spill, ha en quiz, ta
                en dans – beveg deg, rett og slett. Det øker kanskje ikke forbrenningen, men så lenge du
                er opptatt med noe, drikker du mindre.
                `,
                }
        ]
    },
    { // 1 tab4 // student 2
        color: 'orange',
        title: 'Slik kan du drikke mindre når du drikker som mest:',
        data: [
            {
                title:'Unngå runder',
                text:`
                Det høres kanskje hyggelig ut å spandere en runde hver, men det er en dårlig idé når du
                prøver å ha kontroll på hvor mye du drikker. Må du spandere? Kjøp noe alkoholfritt til deg
                selv. Har noen allerede tatt den første runden? Vipps penger til den som har gått for å
                bestille, så kan du droppe å være med på de neste rundene.`,
                },
                {
                title:'Annenhver hvit',
                text:`
                Annethvert glass med vann kan være vanskelig å gjennomføre hvis det sosiale
                drikkepresset er sterkt. Sats på å ta annethvert glass med noe alkoholfritt, så er det
                mindre påfallende. Etter en gin & tonic tar du en tonic, etter en øl tar du en alkoholfri øl.
                Ingen kommer til å se forskjell, og du slipper unna kommentarene.`,
                },
                {
                title:'Spis først',
                text:`
                Spis godt. Sørg for at du aldri drikker på tom mage. Spis gjerne middag før du drikker.
                Maten beskytter magen mot irritasjon og bidrar til at alkoholen ikke tas opp i blodet like
                fort.`,
                },
                {
                title:'La glasset hvile',
                text:`
                Mange ganger går hånden opp til munnen helt automatisk. Kanskje står du med glasset i
                hånden hele tiden fordi det er godt å ha noe å holde i?
                Drikk saktere ved å sette fra deg glasset etter hver slurk.`,
                },
                {
                title:'Lavere alkoholinnhold',
                text:`
                Velg et svakere alternativ. Be om en snillere drink. Ta en lettøl. Velg vin med lavere
                alkoholinnhold.
                Jo langsommere du får i deg alkoholen, desto bedre.`,
                },
                {
                title:'Ikke si “nja …”',
                text:`
                Forskning viser at det har god effekt å begynne setningen med et nei når du vil avstå fra
                alkohol.
                Når du er tydelig fra starten av, er risikoen for å vakle mindre, og den som spør, får mindre
                rom for å prøve å overtale deg.
                “Nei, jeg står over. Hvordan går det med fotballen, spilte ikke dere kamp forrige uke?”`,
                },
                {
                title:'Jug i vei!',
                text:`
                Selv om du prøver å redusere alkoholinntaket, er det ikke sikkert at du har lyst til å snakke
                om det hele tiden. Med noe alkoholfritt i glasset skiller du deg ikke ut, og forhåpentligvis
                unngår du diskusjoner og mas. Det kan være godt å ha noe i hånden, og da kan du også
                være med når det skal skåles, men ingen trenger å få vite at det ikke er alkohol du drikker.`,
                },
                {
                title:'Gjør noe',
                text:`
                Når man bare sitter og snakker, drikker man ofte mer. Gjør noe! Spill biljard, dans, ha en
                quiz – beveg deg, rett og slett. Det øker kanskje ikke forbrenningen, men så lenge du er
                opptatt med noe, drikker du mindre.
                `,
                },
        ]
    },
    { // 1 tab5 // jobber annet 3
        color: 'orange',
        title: 'Slik kan du drikke mindre når du drikker som mest:',
        data: [
            {
                title:'Maraton­middager',
                text:`
                Å holde alkoholinntaket på et passende nivå kan være vanskelig ved lengre middager. Det er fort
gjort at man drikker for mye bare for å ha noe å gjøre.
Test ut å bare drikke alkohol når det skåles, og hold det til noe alkoholfritt mellom skålingen.`
                },
            {
                title:'Unngå runder',
                text:`
                Det høres kanskje hyggelig ut å spandere en runde hver, men det er en dårlig idé når du
                prøver å ha kontroll på hvor mye du drikker. Må du spandere? Kjøp noe alkoholfritt til deg
                selv. Har noen allerede tatt den første runden? Vipps penger til den som har gått for å
                bestille, så kan du droppe å være med på de neste rundene.`
                },
                {
                title:'Annenhver hvit',
                text:`
                Annethvert glass med vann kan være vanskelig å gjennomføre hvis det sosiale
                drikkepresset er sterkt. Sats på å ta annethvert glass med noe alkoholfritt, så er det
                mindre påfallende. Etter en gin & tonic tar du en tonic, etter en øl tar du en alkoholfri øl.
                Ingen kommer til å se forskjell, og du slipper unna kommentarene.`
                },
                {
                title:'Spis først',
                text:`
                Spis godt. Sørg for at du aldri drikker på tom mage. Spis gjerne middag før du drikker.
                Maten beskytter magen mot irritasjon og bidrar til at alkoholen ikke tas opp i blodet like
                fort.`
                },
                {
                title:'La glasset hvile',
                text:`
                Mange ganger går armen til munnen helt automatisk. Kanskje står du med glasset i
                hånden hele tiden fordi det er godt å ha noe å holde i?
                Drikk saktere ved å sette fra deg glasset etter hver slurk.`
                },
                {
                title:'Lavere alkoholinnhold',
                text:`
                Velg et svakere alternativ. Be om en snillere drink. Ta en lettøl. Velg vin med lavere
                alkoholinnhold.
                Jo langsommere du får i deg alkoholen, desto bedre.`
                },
                {
                title:'Ikke si “nja …”',
                text:`
                Forskning viser at det har god effekt å begynne setningen med et nei når du vil avstå fra
                alkohol.
                Når du er tydelig fra starten av, er risikoen for å vakle mindre, og den som spør, får mindre
                rom for å prøve å overtale deg.
                “Nei, jeg står over. Hvordan går det med fotballen, spilte ikke dere kamp forrige uke?”`
                },
                {
                title:'Jug i vei!',
                text:`
                Selv om du prøver å redusere alkoholinntaket, er det ikke sikkert at du har lyst til å snakke
                om det hele tiden. Med noe alkoholfritt i glasset skiller du deg ikke ut, og forhåpentligvis
                unngår du diskusjoner og mas. Det kan være godt å ha noe i hånden, og da kan du også
                være med når det skal skåles, men ingen trenger å få vite at det ikke er alkohol du drikker.`
                },
                {
                title:'Gjør noe',
                text:`
                Når man bare sitter og snakker, drikker man ofte mer. Gjør noe! Spill biljard, dans, ha en
                quiz – beveg deg, rett og slett. Det øker kanskje ikke forbrenningen, men så lenge du er
                opptatt med noe, drikker du mindre.`
                },
        ]
    },
    { // 1 tab6 // pensjonist
        color: 'orange',
        title: 'Slik kan du drikke mindre når du drikker som mest:',
        data: [
            {
                title:'Maraton­middager',
                text:`
                Å holde alkoholinntaket på et passende nivå kan være vanskelig ved lengre middager. Det er fort
gjort at man drikker for mye, når man blir sittende lenge.
Test ut å bare drikke alkohol når det skåles, og hold det til noe alkoholfritt mellom skålingen.`
                },
            {
                title:'Dropp kartong',
                text:`
                Det er mye vanskeligere å holde oversikt over hvor mye du du har drukket når du drikker
                vin fra kartong. Det er også veldig mye lettere å bare ta seg et lite glass til – og så ett til og
                enda et lite glass – noe som du kanskje hadde hoppet over om du hadde vært nødt til å
                åpne en helt ny flaske.`,
                },
                {
                title:'Unngå runder',
                text:`
                Det høres kanskje hyggelig ut å spandere en runde hver, men det er en dårlig idé når du
                prøver å ha kontroll på hvor mye du drikker. Må du spandere? Kjøp noe alkoholfritt til deg
                selv. Har noen allerede tatt den første runden? Vipps penger til den som har gått for å
                bestille, så kan du droppe å være med på de neste rundene.`,
                },
                {
                title:'Annenhver hvit',
                text:`
                Annethvert glass med vann kan være vanskelig å gjennomføre hvis det sosiale
                drikkepresset er sterkt. Sats på å ta annethvert glass med noe alkoholfritt, så er det
                mindre påfallende. Etter en kaffe & baileys tar du en kaffe, etter en øl tar du en alkoholfri
                øl. Ingen kommer til å se forskjell, og du slipper unna kommentarene.`,
                },
                {
                title:'Spis først',
                text:`
                Spis godt. Sørg for at du aldri drikker på tom mage. Spis gjerne middag før du drikker.
                Maten beskytter magen mot irritasjon og bidrar til at alkoholen ikke tas opp i blodet like
                fort.`,
                },
                {
                title:'La glasset hvile',
                text:`
                Mange ganger går hånden til munnen helt automatisk. Kanskje har du glasset i hånden
                hele tiden fordi det er godt å ha noe å holde i?
                Drikk saktere ved å sette fra deg glasset etter hver slurk.`,
                },
                {
                title:'Lavere alkoholinnhold',
                text:`
                Velg et svakere alternativ. Ta en lettøl. Velg vin med lavere alkoholinnhold.
                Jo langsommere du får i deg alkoholen, desto bedre. Kroppen tåler også alkohol dårligere
                med økende alder.`,
                },
                {
                title:'Ikke si “nja …”',
                text:`
                Forskning viser at det har god effekt å begynne setningen med et nei når du vil avstå fra
                alkohol.
                Når du er tydelig fra starten av, er risikoen for å vakle mindre, og den som spør, får mindre
                rom for å prøve å overtale deg.
                “Nei, jeg står over. Hvordan går det med fotballen, spilte ikke dere kamp forrige uke?”`,
                },
                {
                title:'Jug i vei!',
                text:`
                Selv om du prøver å redusere alkoholinntaket, er det ikke sikkert at du har lyst til å snakke
                om det hele tiden. Med noe alkoholfritt i glasset skiller du deg ikke ut, og forhåpentligvis
                unngår du diskusjoner og mas. Det kan være godt å ha noe i hånden, og da kan du også
                være med når det skal skåles, men ingen trenger å få vite at det ikke er alkohol du drikker.`,
                },
                {
                title:'Gjør noe',
                text:`
                Når man bare sitter og snakker, drikker man ofte mer. Gjør noe! Spill et spill, ha en quiz, ta
                en dans – beveg deg, rett og slett. Det øker kanskje ikke forbrenningen, men så lenge du
                er opptatt med noe, drikker du mindre.
                `,
                }
        ]
    },
    { // 1 tab7 // student 3
        color: 'orange',
        title: 'Slik kan du drikke mindre når du drikker som mest:',
        data: [
            {
                title:'Maraton­middager',
                text:`
                Å holde alkoholinntaket på et passende nivå kan være vanskelig ved lengre middager. Det er fort
gjort at man drikker for mye bare for å ha noe å gjøre.
Test ut å bare drikke alkohol når det skåles, og hold det til noe alkoholfritt mellom skålingen.`
            },
            {
                title:'Spis i løpet av kvelden',
                text:`
                Har du en lang festkveld foran deg? Pass på å fylle på med mat etter hvert som timene går. Det
holder ikke å ta en kjapp pølse i brød på kiosken før vorspielet hvis du faktisk fester til neste
morgen. Få i deg litt å spise underveis for å unngå at de sene drinkene går fort over i blodet og du
plutselig ender opp med fyll som du ikke ønsker.`
            },
            {
                title:'Helt om dagen, helt om natten',
                text:`
                Ved store studentfester er det ikke uvanlig å begynne å drikke tidlig på dagen. Men for å holde
hele festen er det bra å spre alkoholkonsumet utover i tid. Brems ned når du kjenner at du er glad
og fornøyd, men før du begynner å snøvle og blir høylytt.
Drikk alkoholfritt en stund. Ellers kan det fort skje at du drikker raskere enn hva kroppen rekker å
forbrenne. De fleste forbrenner 1,5-2 cl sprit per time.`
            },
            {
                title:'Unngå runder',
                text:`
                Det høres kanskje hyggelig ut å spandere en runde hver, men det er en dårlig idé når du
                prøver å ha kontroll på hvor mye du drikker. Må du spandere? Kjøp noe alkoholfritt til deg
                selv. Har noen allerede tatt den første runden? Vipps penger til den som har gått for å
                bestille, så kan du droppe å være med på de neste rundene.`,
                },
                {
                title:'Annenhver hvit',
                text:`
                Annethvert glass med vann kan være vanskelig å gjennomføre hvis det sosiale
                drikkepresset er sterkt. Sats på å ta annethvert glass med noe alkoholfritt, så er det
                mindre påfallende. Etter en gin & tonic tar du en tonic, etter en øl tar du en alkoholfri øl.
                Ingen kommer til å se forskjell, og du slipper unna kommentarene.`,
                },
                {
                title:'Spis først',
                text:`
                Spis godt. Sørg for at du aldri drikker på tom mage. Spis gjerne middag før du drikker.
                Maten beskytter magen mot irritasjon og bidrar til at alkoholen ikke tas opp i blodet like
                fort.`,
                },
                {
                title:'La glasset hvile',
                text:`
                Mange ganger går hånden opp til munnen helt automatisk. Kanskje står du med glasset i
                hånden hele tiden fordi det er godt å ha noe å holde i?
                Drikk saktere ved å sette fra deg glasset etter hver slurk.`,
                },
                {
                title:'Lavere alkoholinnhold',
                text:`
                Velg et svakere alternativ. Be om en snillere drink. Ta en lettøl. Velg vin med lavere
                alkoholinnhold.
                Jo langsommere du får i deg alkoholen, desto bedre.`,
                },
                {
                title:'Ikke si “nja …”',
                text:`
                Forskning viser at det har god effekt å begynne setningen med et nei når du vil avstå fra
                alkohol.
                Når du er tydelig fra starten av, er risikoen for å vakle mindre, og den som spør, får mindre
                rom for å prøve å overtale deg.
                “Nei, jeg står over. Hvordan går det med fotballen, spilte ikke dere kamp forrige uke?”`,
                },
                {
                title:'Jug i vei!',
                text:`
                Selv om du prøver å redusere alkoholinntaket, er det ikke sikkert at du har lyst til å snakke
                om det hele tiden. Med noe alkoholfritt i glasset skiller du deg ikke ut, og forhåpentligvis
                unngår du diskusjoner og mas. Det kan være godt å ha noe i hånden, og da kan du også
                være med når det skal skåles, men ingen trenger å få vite at det ikke er alkohol du drikker.`,
                },
                {
                title:'Gjør noe',
                text:`
                Når man bare sitter og snakker, drikker man ofte mer. Gjør noe! Spill biljard, dans, ha en
                quiz – beveg deg, rett og slett. Det øker kanskje ikke forbrenningen, men så lenge du er
                opptatt med noe, drikker du mindre.
                `,
                },
        ]
    },
    { // 1 tab8 // jobber annet 4
        color: 'orange',
        title: 'Slik kan du drikke mindre når du drikker som mest:',
        data: [
            {
                title:'Ha en plan for kvelden',
                text:`
                Det er lettere å drikke mindre dersom du har en plan for kvelden. Tenk igjennom drikkingen
                din og på hvordan en fin kveld vil være for deg. Hvor mye kan du drikke uten at det ender
                ille? Bestem deg på forhånd, ha en plan og hold deg til den.`,
                },
                {
                title:'Bestem hvor lenge det skal vare',
                text:`
                Drikk med pause. Bestem hvor lenge drinken din skal vare før du får ta den neste. En
                time? 45 minutter?
                Sett på en lydløs alarm på mobilen hvis du trenger hjelp med å holde deg til planen. Ikke
                noe nytt glass med alkohol før alarmen går.`,
                },
                {
                title:'Cruise control',
                text:`
                Følg med på noen på festen som du vet drikker mindre og i rolig tempo, og hold tempoet til
                den personen.`,
                },
                {
                title:'Stoppetid',
                text:`
                Slutt å drikke i tide. Det kan være et problem at du fortsetter å drikke for lenge, og får i
                deg store mengder alkohol i det festen egentlig er over.
                Bestem deg for et klokkeslett som er tilstrekkelig, og sett på en lydløs alarm på telefonen.
                Når den begynner å vibrere er det på tide å gå over til vann eller alkoholfritt.`,
                },
                {
                title:'Små slurker',
                text:`
                Sørg for at du drikker saktere ved å ta små slurker når du drikker. Ta deg tid til å heller
                kjenne ordentlig på smaken hver gang før du svelger. Sett ned glasset etter hver slurk.
                Jo saktere du drikker, desto mindre alkohol rekker du å få i deg.`,
                },
            {
                title:'Maraton­middager',
                text:`
                Å holde alkoholinntaket på et passende nivå kan være vanskelig ved lengre middager. Det er fort
gjort at man drikker for mye bare for å ha noe å gjøre.
Test ut å bare drikke alkohol når det skåles, og hold det til noe alkoholfritt mellom skålingen.`
                },
            {
                title:'Unngå runder',
                text:`
                Det høres kanskje hyggelig ut å spandere en runde hver, men det er en dårlig idé når du
                prøver å ha kontroll på hvor mye du drikker. Må du spandere? Kjøp noe alkoholfritt til deg
                selv. Har noen allerede tatt den første runden? Vipps penger til den som har gått for å
                bestille, så kan du droppe å være med på de neste rundene.`
                },
                {
                title:'Annenhver hvit',
                text:`
                Annethvert glass med vann kan være vanskelig å gjennomføre hvis det sosiale
                drikkepresset er sterkt. Sats på å ta annethvert glass med noe alkoholfritt, så er det
                mindre påfallende. Etter en gin & tonic tar du en tonic, etter en øl tar du en alkoholfri øl.
                Ingen kommer til å se forskjell, og du slipper unna kommentarene.`
                },
                {
                title:'Spis først',
                text:`
                Spis godt. Sørg for at du aldri drikker på tom mage. Spis gjerne middag før du drikker.
                Maten beskytter magen mot irritasjon og bidrar til at alkoholen ikke tas opp i blodet like
                fort.`
                },
                {
                title:'La glasset hvile',
                text:`
                Mange ganger går armen til munnen helt automatisk. Kanskje står du med glasset i
                hånden hele tiden fordi det er godt å ha noe å holde i?
                Drikk saktere ved å sette fra deg glasset etter hver slurk.`
                },
                {
                title:'Lavere alkoholinnhold',
                text:`
                Velg et svakere alternativ. Be om en snillere drink. Ta en lettøl. Velg vin med lavere
                alkoholinnhold.
                Jo langsommere du får i deg alkoholen, desto bedre.`
                },
                {
                title:'Ikke si “nja …”',
                text:`
                Forskning viser at det har god effekt å begynne setningen med et nei når du vil avstå fra
                alkohol.
                Når du er tydelig fra starten av, er risikoen for å vakle mindre, og den som spør, får mindre
                rom for å prøve å overtale deg.
                “Nei, jeg står over. Hvordan går det med fotballen, spilte ikke dere kamp forrige uke?”`
                },
                {
                title:'Jug i vei!',
                text:`
                Selv om du prøver å redusere alkoholinntaket, er det ikke sikkert at du har lyst til å snakke
                om det hele tiden. Med noe alkoholfritt i glasset skiller du deg ikke ut, og forhåpentligvis
                unngår du diskusjoner og mas. Det kan være godt å ha noe i hånden, og da kan du også
                være med når det skal skåles, men ingen trenger å få vite at det ikke er alkohol du drikker.`
                },
                {
                title:'Gjør noe',
                text:`
                Når man bare sitter og snakker, drikker man ofte mer. Gjør noe! Spill biljard, dans, ha en
                quiz – beveg deg, rett og slett. Det øker kanskje ikke forbrenningen, men så lenge du er
                opptatt med noe, drikker du mindre.`
                },
        ]
    },
    { // 1 tab9 // pensjonist 4
        color: 'orange',
        title: 'Slik kan du drikke mindre når du drikker som mest:',
        data: [
            {
                title:'Ha en plan for kvelden',
                text:`
                Det er lettere å drikke mindre dersom du har en plan for kvelden. Tenk igjennom drikkingen
                din og på hvordan en fin kveld vil være for deg. Hvor mye kan du drikke uten at det ender
                ille? Bestem deg på forhånd, ha en plan og hold deg til den.`,
                },
                {
                title:'Bestem hvor lenge det skal vare',
                text:`
                Drikk med pause. Bestem hvor lenge drinken din skal vare før du får ta den neste. En
                time? 45 minutter?
                Sett på en lydløs alarm på mobilen hvis du trenger hjelp med å holde deg til planen. Ikke
                noe nytt glass med alkohol før alarmen går.`,
                },
                {
                title:'Cruise control',
                text:`
                Følg med på noen på festen som du vet drikker mindre og i rolig tempo, og hold tempoet til
                den personen.`,
                },
                {
                    title:'Maraton­middager',
                    text:`
                    Å holde alkoholinntaket på et passende nivå kan være vanskelig ved lengre middager. Det er fort
    gjort at man drikker for mye, når man blir sittende lenge.
    Test ut å bare drikke alkohol når det skåles, og hold det til noe alkoholfritt mellom skålingen.`
                    },
            {
                title:'Dropp kartong',
                text:`
                Det er mye vanskeligere å holde oversikt over hvor mye du du har drukket når du drikker
                vin fra kartong. Det er også veldig mye lettere å bare ta seg et lite glass til – og så ett til og
                enda et lite glass – noe som du kanskje hadde hoppet over om du hadde vært nødt til å
                åpne en helt ny flaske.`,
                },
                {
                title:'Unngå runder',
                text:`
                Det høres kanskje hyggelig ut å spandere en runde hver, men det er en dårlig idé når du
                prøver å ha kontroll på hvor mye du drikker. Må du spandere? Kjøp noe alkoholfritt til deg
                selv. Har noen allerede tatt den første runden? Vipps penger til den som har gått for å
                bestille, så kan du droppe å være med på de neste rundene.`,
                },
                {
                title:'Annenhver hvit',
                text:`
                Annethvert glass med vann kan være vanskelig å gjennomføre hvis det sosiale
                drikkepresset er sterkt. Sats på å ta annethvert glass med noe alkoholfritt, så er det
                mindre påfallende. Etter en kaffe & baileys tar du en kaffe, etter en øl tar du en alkoholfri
                øl. Ingen kommer til å se forskjell, og du slipper unna kommentarene.`,
                },
                {
                title:'Spis først',
                text:`
                Spis godt. Sørg for at du aldri drikker på tom mage. Spis gjerne middag før du drikker.
                Maten beskytter magen mot irritasjon og bidrar til at alkoholen ikke tas opp i blodet like
                fort.`,
                },
                {
                title:'La glasset hvile',
                text:`
                Mange ganger går hånden til munnen helt automatisk. Kanskje har du glasset i hånden
                hele tiden fordi det er godt å ha noe å holde i?
                Drikk saktere ved å sette fra deg glasset etter hver slurk.`,
                },
                {
                title:'Lavere alkoholinnhold',
                text:`
                Velg et svakere alternativ. Ta en lettøl. Velg vin med lavere alkoholinnhold.
                Jo langsommere du får i deg alkoholen, desto bedre. Kroppen tåler også alkohol dårligere
                med økende alder.`,
                },
                {
                title:'Ikke si “nja …”',
                text:`
                Forskning viser at det har god effekt å begynne setningen med et nei når du vil avstå fra
                alkohol.
                Når du er tydelig fra starten av, er risikoen for å vakle mindre, og den som spør, får mindre
                rom for å prøve å overtale deg.
                “Nei, jeg står over. Hvordan går det med fotballen, spilte ikke dere kamp forrige uke?”`,
                },
                {
                title:'Jug i vei!',
                text:`
                Selv om du prøver å redusere alkoholinntaket, er det ikke sikkert at du har lyst til å snakke
                om det hele tiden. Med noe alkoholfritt i glasset skiller du deg ikke ut, og forhåpentligvis
                unngår du diskusjoner og mas. Det kan være godt å ha noe i hånden, og da kan du også
                være med når det skal skåles, men ingen trenger å få vite at det ikke er alkohol du drikker.`,
                },
                {
                title:'Gjør noe',
                text:`
                Når man bare sitter og snakker, drikker man ofte mer. Gjør noe! Spill et spill, ha en quiz, ta
                en dans – beveg deg, rett og slett. Det øker kanskje ikke forbrenningen, men så lenge du
                er opptatt med noe, drikker du mindre.
                `,
                }
        ]
    },
    { // 1 tab10 // student 4
        color: 'orange',
        title: 'Slik kan du drikke mindre når du drikker som mest:',
        data: [
            {
                title:'Ha en plan for kvelden',
                text:`
                Det er lettere å drikke mindre dersom du har en plan for kvelden. Tenk igjennom drikkingen
                din og på hvordan en fin kveld vil være for deg. Hvor mye kan du drikke uten at det ender
                ille? Bestem deg på forhånd, ha en plan og hold deg til den.`,
                },
                {
                title:'Bestem hvor lenge det skal vare',
                text:`
                Drikk med pause. Bestem hvor lenge drinken din skal vare før du får ta den neste. En
                time? 45 minutter?
                Sett på en lydløs alarm på mobilen hvis du trenger hjelp med å holde deg til planen. Ikke
                noe nytt glass med alkohol før alarmen går.`,
                },
                {
                title:'Cruise control',
                text:`
                Følg med på noen på festen som du vet drikker mindre og i rolig tempo, og hold tempoet til
                den personen.`,
                },
                {
                title:'Stoppetid',
                text:`
                Slutt å drikke i tide. Det kan være et problem at du fortsetter å drikke for lenge, og får i
                deg store mengder alkohol i det festen egentlig er over.
                Bestem deg for et klokkeslett som er tilstrekkelig, og sett på en lydløs alarm på telefonen.
                Når den begynner å vibrere er det på tide å gå over til vann eller alkoholfritt.`,
                },
                {
                title:'Små slurker',
                text:`
                Sørg for at du drikker saktere ved å ta små slurker når du drikker. Ta deg tid til å heller
                kjenne ordentlig på smaken hver gang før du svelger. Sett ned glasset etter hver slurk.
                Jo saktere du drikker, desto mindre alkohol rekker du å få i deg.`,
                },
            {
                title:'Maraton­middager',
                text:`
                Å holde alkoholinntaket på et passende nivå kan være vanskelig ved lengre middager. Det er fort
gjort at man drikker for mye bare for å ha noe å gjøre.
Test ut å bare drikke alkohol når det skåles, og hold det til noe alkoholfritt mellom skålingen.`
            },
            {
                title:'Spis i løpet av kvelden',
                text:`
                Har du en lang festkveld foran deg? Pass på å fylle på med mat etter hvert som timene går. Det
holder ikke å ta en kjapp pølse i brød på kiosken før vorspielet hvis du faktisk fester til neste
morgen. Få i deg litt å spise underveis for å unngå at de sene drinkene går fort over i blodet og du
plutselig ender opp med fyll som du ikke ønsker.`
            },
            {
                title:'Helt om dagen, helt om natten',
                text:`
                Ved store studentfester er det ikke uvanlig å begynne å drikke tidlig på dagen. Men for å holde
hele festen er det bra å spre alkoholkonsumet utover i tid. Brems ned når du kjenner at du er glad
og fornøyd, men før du begynner å snøvle og blir høylytt.
Drikk alkoholfritt en stund. Ellers kan det fort skje at du drikker raskere enn hva kroppen rekker å
forbrenne. De fleste forbrenner 1,5-2 cl sprit per time.`
            },
            {
                title:'Unngå runder',
                text:`
                Det høres kanskje hyggelig ut å spandere en runde hver, men det er en dårlig idé når du
                prøver å ha kontroll på hvor mye du drikker. Må du spandere? Kjøp noe alkoholfritt til deg
                selv. Har noen allerede tatt den første runden? Vipps penger til den som har gått for å
                bestille, så kan du droppe å være med på de neste rundene.`,
                },
                {
                title:'Annenhver hvit',
                text:`
                Annethvert glass med vann kan være vanskelig å gjennomføre hvis det sosiale
                drikkepresset er sterkt. Sats på å ta annethvert glass med noe alkoholfritt, så er det
                mindre påfallende. Etter en gin & tonic tar du en tonic, etter en øl tar du en alkoholfri øl.
                Ingen kommer til å se forskjell, og du slipper unna kommentarene.`,
                },
                {
                title:'Spis først',
                text:`
                Spis godt. Sørg for at du aldri drikker på tom mage. Spis gjerne middag før du drikker.
                Maten beskytter magen mot irritasjon og bidrar til at alkoholen ikke tas opp i blodet like
                fort.`,
                },
                {
                title:'La glasset hvile',
                text:`
                Mange ganger går hånden opp til munnen helt automatisk. Kanskje står du med glasset i
                hånden hele tiden fordi det er godt å ha noe å holde i?
                Drikk saktere ved å sette fra deg glasset etter hver slurk.`,
                },
                {
                title:'Lavere alkoholinnhold',
                text:`
                Velg et svakere alternativ. Be om en snillere drink. Ta en lettøl. Velg vin med lavere
                alkoholinnhold.
                Jo langsommere du får i deg alkoholen, desto bedre.`,
                },
                {
                title:'Ikke si “nja …”',
                text:`
                Forskning viser at det har god effekt å begynne setningen med et nei når du vil avstå fra
                alkohol.
                Når du er tydelig fra starten av, er risikoen for å vakle mindre, og den som spør, får mindre
                rom for å prøve å overtale deg.
                “Nei, jeg står over. Hvordan går det med fotballen, spilte ikke dere kamp forrige uke?”`,
                },
                {
                title:'Jug i vei!',
                text:`
                Selv om du prøver å redusere alkoholinntaket, er det ikke sikkert at du har lyst til å snakke
                om det hele tiden. Med noe alkoholfritt i glasset skiller du deg ikke ut, og forhåpentligvis
                unngår du diskusjoner og mas. Det kan være godt å ha noe i hånden, og da kan du også
                være med når det skal skåles, men ingen trenger å få vite at det ikke er alkohol du drikker.`,
                },
                {
                title:'Gjør noe',
                text:`
                Når man bare sitter og snakker, drikker man ofte mer. Gjør noe! Spill biljard, dans, ha en
                quiz – beveg deg, rett og slett. Det øker kanskje ikke forbrenningen, men så lenge du er
                opptatt med noe, drikker du mindre.
                `,
                },
        ]
    },
    { // 1 tab11 // jobber annet 5
        color: 'orange',
        title: 'Slik kan du drikke mindre når du drikker som mest:',
        data: [
            {
                title:'Gjør en viktig avtale',
                text:`
                Hvis du har problemer med å slutte å drikke i tide – gjør en viktig avtale eller planlegg noe
                som du vet at det ikke vil gå glipp av, noe som gjør at du må være pigg neste morgen. Det
                kan hjelpe deg til å drikke mindre utover kvelden.`,
                },
                {
                title:'Påminnelse',
                text:`
                Hvis drikkingen din får konsekvenser for deg og for de rundt deg – du kan senke tempoet
                utover kvelden ved å minne deg på de positive konsekvensene av å drikke mindre.
                Bytt bilde på mobilen til en situasjon eller person som minner deg på hva du ønsker å oppnå.
                Da blir det lettere å huske på hvorfor du prøver å drikke smartere og hva du ønsker å
                unngå.`,
                },
                {
                title:'Be om hjelp fra venner',
                text:`
                Å få støtte av noen som du stoler på kan være til stor hjelp. Fortell at du prøver å drikke
                mindre, og be om hjelp.
                Spør om kompisen eller venninnen din kan hjelpe deg ved å finne på ting dere kan gjøre
                sammen som ikke inkluderer alkohol. Eller be om støtte i sosiale situasjoner der det er
                forventning om at det skal drikkes.`,
                },
            {
                title:'Ha en plan for kvelden',
                text:`
                Det er lettere å drikke mindre dersom du har en plan for kvelden. Tenk igjennom drikkingen
                din og på hvordan en fin kveld vil være for deg. Hvor mye kan du drikke uten at det ender
                ille? Bestem deg på forhånd, ha en plan og hold deg til den.`,
                },
                {
                title:'Bestem hvor lenge det skal vare',
                text:`
                Drikk med pause. Bestem hvor lenge drinken din skal vare før du får ta den neste. En
                time? 45 minutter?
                Sett på en lydløs alarm på mobilen hvis du trenger hjelp med å holde deg til planen. Ikke
                noe nytt glass med alkohol før alarmen går.`,
                },
                {
                title:'Cruise control',
                text:`
                Følg med på noen på festen som du vet drikker mindre og i rolig tempo, og hold tempoet til
                den personen.`,
                },
                {
                title:'Stoppetid',
                text:`
                Slutt å drikke i tide. Det kan være et problem at du fortsetter å drikke for lenge, og får i
                deg store mengder alkohol i det festen egentlig er over.
                Bestem deg for et klokkeslett som er tilstrekkelig, og sett på en lydløs alarm på telefonen.
                Når den begynner å vibrere er det på tide å gå over til vann eller alkoholfritt.`,
                },
                {
                title:'Små slurker',
                text:`
                Sørg for at du drikker saktere ved å ta små slurker når du drikker. Ta deg tid til å heller
                kjenne ordentlig på smaken hver gang før du svelger. Sett ned glasset etter hver slurk.
                Jo saktere du drikker, desto mindre alkohol rekker du å få i deg.`,
                },
            {
                title:'Maraton­middager',
                text:`
                Å holde alkoholinntaket på et passende nivå kan være vanskelig ved lengre middager. Det er fort
gjort at man drikker for mye bare for å ha noe å gjøre.
Test ut å bare drikke alkohol når det skåles, og hold det til noe alkoholfritt mellom skålingen.`
                },
            {
                title:'Unngå runder',
                text:`
                Det høres kanskje hyggelig ut å spandere en runde hver, men det er en dårlig idé når du
                prøver å ha kontroll på hvor mye du drikker. Må du spandere? Kjøp noe alkoholfritt til deg
                selv. Har noen allerede tatt den første runden? Vipps penger til den som har gått for å
                bestille, så kan du droppe å være med på de neste rundene.`
                },
                {
                title:'Annenhver hvit',
                text:`
                Annethvert glass med vann kan være vanskelig å gjennomføre hvis det sosiale
                drikkepresset er sterkt. Sats på å ta annethvert glass med noe alkoholfritt, så er det
                mindre påfallende. Etter en gin & tonic tar du en tonic, etter en øl tar du en alkoholfri øl.
                Ingen kommer til å se forskjell, og du slipper unna kommentarene.`
                },
                {
                title:'Spis først',
                text:`
                Spis godt. Sørg for at du aldri drikker på tom mage. Spis gjerne middag før du drikker.
                Maten beskytter magen mot irritasjon og bidrar til at alkoholen ikke tas opp i blodet like
                fort.`
                },
                {
                title:'La glasset hvile',
                text:`
                Mange ganger går armen til munnen helt automatisk. Kanskje står du med glasset i
                hånden hele tiden fordi det er godt å ha noe å holde i?
                Drikk saktere ved å sette fra deg glasset etter hver slurk.`
                },
                {
                title:'Lavere alkoholinnhold',
                text:`
                Velg et svakere alternativ. Be om en snillere drink. Ta en lettøl. Velg vin med lavere
                alkoholinnhold.
                Jo langsommere du får i deg alkoholen, desto bedre.`
                },
                {
                title:'Ikke si “nja …”',
                text:`
                Forskning viser at det har god effekt å begynne setningen med et nei når du vil avstå fra
                alkohol.
                Når du er tydelig fra starten av, er risikoen for å vakle mindre, og den som spør, får mindre
                rom for å prøve å overtale deg.
                “Nei, jeg står over. Hvordan går det med fotballen, spilte ikke dere kamp forrige uke?”`
                },
                {
                title:'Jug i vei!',
                text:`
                Selv om du prøver å redusere alkoholinntaket, er det ikke sikkert at du har lyst til å snakke
                om det hele tiden. Med noe alkoholfritt i glasset skiller du deg ikke ut, og forhåpentligvis
                unngår du diskusjoner og mas. Det kan være godt å ha noe i hånden, og da kan du også
                være med når det skal skåles, men ingen trenger å få vite at det ikke er alkohol du drikker.`
                },
                {
                title:'Gjør noe',
                text:`
                Når man bare sitter og snakker, drikker man ofte mer. Gjør noe! Spill biljard, dans, ha en
                quiz – beveg deg, rett og slett. Det øker kanskje ikke forbrenningen, men så lenge du er
                opptatt med noe, drikker du mindre.`
                },
        ]
    },
    { // 1 tab12 // pensjonist 5
        color: 'orange',
        title: 'Slik kan du drikke mindre når du drikker som mest:',
        data: [
            {
                title:'Gjør en viktig avtale',
                text:`
                Hvis du har problemer med å slutte å drikke i tide – gjør en viktig avtale eller planlegg noe
                som du vet at det ikke vil gå glipp av, noe som gjør at du må være pigg neste morgen. Det
                kan hjelpe deg til å drikke mindre utover kvelden.`,
                },
                {
                title:'Påminnelse',
                text:`
                Hvis drikkingen din får konsekvenser for deg og for de rundt deg – du kan senke tempoet
                utover kvelden ved å minne deg på de positive konsekvensene av å drikke mindre.
                Bytt bilde på mobilen til en situasjon eller person som minner deg på hva du ønsker å oppnå.
                Da blir det lettere å huske på hvorfor du prøver å drikke smartere og hva du ønsker å
                unngå.`,
                },
                {
                title:'Be om hjelp fra venner',
                text:`
                Å få støtte av noen som du stoler på kan være til stor hjelp. Fortell at du prøver å drikke
                mindre, og be om hjelp.
                Spør om en venn, venninne eller partneren din kan hjelpe deg med å finne på ting dere
kan gjøre sammen som ikke inkluderer alkohol. Eller be om støtte i sosiale situasjoner der
det er forventning om at det skal drikkes.`,
                },
            {
                title:'Ha en plan for kvelden',
                text:`
                Det er lettere å drikke mindre dersom du har en plan for kvelden. Tenk igjennom drikkingen
                din og på hvordan en fin kveld vil være for deg. Hvor mye kan du drikke uten at det ender
                ille? Bestem deg på forhånd, ha en plan og hold deg til den.`,
                },
                {
                title:'Bestem hvor lenge det skal vare',
                text:`
                Drikk med pause. Bestem hvor lenge drinken din skal vare før du får ta den neste. En
                time? 45 minutter?
                Sett på en lydløs alarm på mobilen hvis du trenger hjelp med å holde deg til planen. Ikke
                noe nytt glass med alkohol før alarmen går.`,
                },
                {
                title:'Cruise control',
                text:`
                Følg med på noen på festen som du vet drikker mindre og i rolig tempo, og hold tempoet til
                den personen.`,
                },
            {
                title:'Maraton­middager',
                text:`
                Å holde alkoholinntaket på et passende nivå kan være vanskelig ved lengre middager. Det er fort
gjort at man drikker for mye bare for å ha noe å gjøre.
Test ut å bare drikke alkohol når det skåles, og hold det til noe alkoholfritt mellom skålingen.`
                },
            {
                title:'Dropp kartong',
                text:`
                Det er mye vanskeligere å holde oversikt over hvor mye du du har drukket når du drikker
                vin fra kartong. Det er også veldig mye lettere å bare ta seg et lite glass til – og så ett til og
                enda et lite glass – noe som du kanskje hadde hoppet over om du hadde vært nødt til å
                åpne en helt ny flaske.`,
                },
                {
                title:'Unngå runder',
                text:`
                Det høres kanskje hyggelig ut å spandere en runde hver, men det er en dårlig idé når du
                prøver å ha kontroll på hvor mye du drikker. Må du spandere? Kjøp noe alkoholfritt til deg
                selv. Har noen allerede tatt den første runden? Vipps penger til den som har gått for å
                bestille, så kan du droppe å være med på de neste rundene.`,
                },
                {
                title:'Annenhver hvit',
                text:`
                Annethvert glass med vann kan være vanskelig å gjennomføre hvis det sosiale
                drikkepresset er sterkt. Sats på å ta annethvert glass med noe alkoholfritt, så er det
                mindre påfallende. Etter en kaffe & baileys tar du en kaffe, etter en øl tar du en alkoholfri
                øl. Ingen kommer til å se forskjell, og du slipper unna kommentarene.`,
                },
                {
                title:'Spis først',
                text:`
                Spis godt. Sørg for at du aldri drikker på tom mage. Spis gjerne middag før du drikker.
                Maten beskytter magen mot irritasjon og bidrar til at alkoholen ikke tas opp i blodet like
                fort.`,
                },
                {
                title:'La glasset hvile',
                text:`
                Mange ganger går hånden til munnen helt automatisk. Kanskje har du glasset i hånden
                hele tiden fordi det er godt å ha noe å holde i?
                Drikk saktere ved å sette fra deg glasset etter hver slurk.`,
                },
                {
                title:'Lavere alkoholinnhold',
                text:`
                Velg et svakere alternativ. Ta en lettøl. Velg vin med lavere alkoholinnhold.
                Jo langsommere du får i deg alkoholen, desto bedre. Kroppen tåler også alkohol dårligere
                med økende alder.`,
                },
                {
                title:'Ikke si “nja …”',
                text:`
                Forskning viser at det har god effekt å begynne setningen med et nei når du vil avstå fra
                alkohol.
                Når du er tydelig fra starten av, er risikoen for å vakle mindre, og den som spør, får mindre
                rom for å prøve å overtale deg.
                “Nei, jeg står over. Hvordan går det med fotballen, spilte ikke dere kamp forrige uke?”`,
                },
                {
                title:'Jug i vei!',
                text:`
                Selv om du prøver å redusere alkoholinntaket, er det ikke sikkert at du har lyst til å snakke
                om det hele tiden. Med noe alkoholfritt i glasset skiller du deg ikke ut, og forhåpentligvis
                unngår du diskusjoner og mas. Det kan være godt å ha noe i hånden, og da kan du også
                være med når det skal skåles, men ingen trenger å få vite at det ikke er alkohol du drikker.`,
                },
                {
                title:'Gjør noe',
                text:`
                Når man bare sitter og snakker, drikker man ofte mer. Gjør noe! Spill et spill, ha en quiz, ta
                en dans – beveg deg, rett og slett. Det øker kanskje ikke forbrenningen, men så lenge du
                er opptatt med noe, drikker du mindre.
                `,
                }
        ]
    },
    { // 1 tab13 // student 5
        color: 'orange',
        title: 'Slik kan du drikke mindre når du drikker som mest:',
        data: [
            {
                title:'Gjør en viktig avtale',
                text:`
                Hvis du har problemer med å slutte å drikke i tide – gjør en viktig avtale eller planlegg noe
                som du vet at det ikke vil gå glipp av, noe som gjør at du må være pigg neste morgen. Det
                kan hjelpe deg til å drikke mindre utover kvelden.`,
                },
                {
                title:'Påminnelse',
                text:`
                Hvis drikkingen din får konsekvenser for deg og for de rundt deg – du kan senke tempoet
                utover kvelden ved å minne deg på de positive konsekvensene av å drikke mindre.
                Bytt bilde på mobilen til en situasjon eller person som minner deg på hva du ønsker å oppnå.
                Da blir det lettere å huske på hvorfor du prøver å drikke smartere og hva du ønsker å
                unngå.`,
                },
                {
                title:'Be om hjelp fra venner',
                text:`
                Å få støtte av noen som du stoler på kan være til stor hjelp. Fortell at du prøver å drikke
                mindre, og be om hjelp.
                Spør om kompisen eller venninnen din kan hjelpe deg ved å finne på ting dere kan gjøre
sammen som ikke inkluderer alkohol. Eller be om støtte i sosiale situasjoner der det er
forventning om at det skal drikkes.`,
                },
            {
                title:'Ha en plan for kvelden',
                text:`
                Det er lettere å drikke mindre dersom du har en plan for kvelden. Tenk igjennom drikkingen
                din og på hvordan en fin kveld vil være for deg. Hvor mye kan du drikke uten at det ender
                ille? Bestem deg på forhånd, ha en plan og hold deg til den.`,
                },
                {
                title:'Bestem hvor lenge det skal vare',
                text:`
                Drikk med pause. Bestem hvor lenge drinken din skal vare før du får ta den neste. En
                time? 45 minutter?
                Sett på en lydløs alarm på mobilen hvis du trenger hjelp med å holde deg til planen. Ikke
                noe nytt glass med alkohol før alarmen går.`,
                },
                {
                title:'Cruise control',
                text:`
                Følg med på noen på festen som du vet drikker mindre og i rolig tempo, og hold tempoet til
                den personen.`,
                },
                {
                title:'Stoppetid',
                text:`
                Slutt å drikke i tide. Det kan være et problem at du fortsetter å drikke for lenge, og får i
                deg store mengder alkohol i det festen egentlig er over.
                Bestem deg for et klokkeslett som er tilstrekkelig, og sett på en lydløs alarm på telefonen.
                Når den begynner å vibrere er det på tide å gå over til vann eller alkoholfritt.`,
                },
                {
                title:'Små slurker',
                text:`
                Sørg for at du drikker saktere ved å ta små slurker når du drikker. Ta deg tid til å heller
                kjenne ordentlig på smaken hver gang før du svelger. Sett ned glasset etter hver slurk.
                Jo saktere du drikker, desto mindre alkohol rekker du å få i deg.`,
                },
            {
                title:'Maraton­middager',
                text:`
                Å holde alkoholinntaket på et passende nivå kan være vanskelig ved lengre middager. Det er fort
gjort at man drikker for mye bare for å ha noe å gjøre.
Test ut å bare drikke alkohol når det skåles, og hold det til noe alkoholfritt mellom skålingen.`
            },
            {
                title:'Spis i løpet av kvelden',
                text:`
                Har du en lang festkveld foran deg? Pass på å fylle på med mat etter hvert som timene går. Det
holder ikke å ta en kjapp pølse i brød på kiosken før vorspielet hvis du faktisk fester til neste
morgen. Få i deg litt å spise underveis for å unngå at de sene drinkene går fort over i blodet og du
plutselig ender opp med fyll som du ikke ønsker.`
            },
            {
                title:'Helt om dagen, helt om natten',
                text:`
                Ved store studentfester er det ikke uvanlig å begynne å drikke tidlig på dagen. Men for å holde
hele festen er det bra å spre alkoholkonsumet utover i tid. Brems ned når du kjenner at du er glad
og fornøyd, men før du begynner å snøvle og blir høylytt.
Drikk alkoholfritt en stund. Ellers kan det fort skje at du drikker raskere enn hva kroppen rekker å
forbrenne. De fleste forbrenner 1,5-2 cl sprit per time.`
            },
            {
                title:'Unngå runder',
                text:`
                Det høres kanskje hyggelig ut å spandere en runde hver, men det er en dårlig idé når du
                prøver å ha kontroll på hvor mye du drikker. Må du spandere? Kjøp noe alkoholfritt til deg
                selv. Har noen allerede tatt den første runden? Vipps penger til den som har gått for å
                bestille, så kan du droppe å være med på de neste rundene.`,
                },
                {
                title:'Annenhver hvit',
                text:`
                Annethvert glass med vann kan være vanskelig å gjennomføre hvis det sosiale
                drikkepresset er sterkt. Sats på å ta annethvert glass med noe alkoholfritt, så er det
                mindre påfallende. Etter en gin & tonic tar du en tonic, etter en øl tar du en alkoholfri øl.
                Ingen kommer til å se forskjell, og du slipper unna kommentarene.`,
                },
                {
                title:'Spis først',
                text:`
                Spis godt. Sørg for at du aldri drikker på tom mage. Spis gjerne middag før du drikker.
                Maten beskytter magen mot irritasjon og bidrar til at alkoholen ikke tas opp i blodet like
                fort.`,
                },
                {
                title:'La glasset hvile',
                text:`
                Mange ganger går hånden opp til munnen helt automatisk. Kanskje står du med glasset i
                hånden hele tiden fordi det er godt å ha noe å holde i?
                Drikk saktere ved å sette fra deg glasset etter hver slurk.`,
                },
                {
                title:'Lavere alkoholinnhold',
                text:`
                Velg et svakere alternativ. Be om en snillere drink. Ta en lettøl. Velg vin med lavere
                alkoholinnhold.
                Jo langsommere du får i deg alkoholen, desto bedre.`,
                },
                {
                title:'Ikke si “nja …”',
                text:`
                Forskning viser at det har god effekt å begynne setningen med et nei når du vil avstå fra
                alkohol.
                Når du er tydelig fra starten av, er risikoen for å vakle mindre, og den som spør, får mindre
                rom for å prøve å overtale deg.
                “Nei, jeg står over. Hvordan går det med fotballen, spilte ikke dere kamp forrige uke?”`,
                },
                {
                title:'Jug i vei!',
                text:`
                Selv om du prøver å redusere alkoholinntaket, er det ikke sikkert at du har lyst til å snakke
                om det hele tiden. Med noe alkoholfritt i glasset skiller du deg ikke ut, og forhåpentligvis
                unngår du diskusjoner og mas. Det kan være godt å ha noe i hånden, og da kan du også
                være med når det skal skåles, men ingen trenger å få vite at det ikke er alkohol du drikker.`,
                },
                {
                title:'Gjør noe',
                text:`
                Når man bare sitter og snakker, drikker man ofte mer. Gjør noe! Spill biljard, dans, ha en
                quiz – beveg deg, rett og slett. Det øker kanskje ikke forbrenningen, men så lenge du er
                opptatt med noe, drikker du mindre.
                `,
                },
        ]
    },
    { // 1 tab14 risiko2
        color: 'red',
        title: 'Slik kan du drikke sjeldnere:',
        data: [
            {
                title:'Planlegg uken din',
                text:`
                Ha en plan som kan måles i glass per uke. Hvor mange glass kan du drikke? Hvilke dager?
                Skriv det ned i kalenderen før uken begynner, og hold deg til denne planen.`,
                },
                {
                title:'Glem barskapet',
                text:`
                Gjør det litt mer tungvint for deg selv å drikke ved å ikke ha alkohol hjemme.
                Skal du ha folk på middag? Kjøp bare det som trengs – dropp den ekstra flasken som “kan
                komme godt med”. Ikke ha favorittdrikken din hjemme.`,
                },
                {
                title:'Finn på andre ting',
                text:`
                Finn på noe annet å gjøre noen kvelder i uken. Prøv en ny treningsform eller noe annet
                som krever litt tid og konsentrasjon. Vær sammen med venner som ikke trenger et glass
                vin eller en øl som påskudd for å møtes.
                Gjør nye ting som du synes er skikkelig morsomme. Da føles det i mindre grad som at du
                ikke får lov til å drikke, men mer som at du får anledning til å gjøre noe annet.`,
                },
                {
                title:'Ikke si “nja …”',
                text:`
                Forskning viser at det har god effekt å begynne setningen med et nei når du vil avstå fra alkohol.
                Når du er tydelig fra starten av, er risikoen for å vakle mindre, og den som spør, får mindre rom for
                å prøve å overtale deg.
                “Nei, jeg står over. Hvordan går det med fotballen, spilte ikke dere kamp forrige uke?”`,
                },
                {
                title:'Jug i vei!',
                text:`
                Selv om du prøver å redusere alkoholinntaket, er det ikke sikkert at du har lyst til å snakke
                om det hele tiden. Med noe alkoholfritt i glasset skiller du deg ikke ut, og forhåpentligvis
                unngår du diskusjoner og mas. Det kan være godt å ha noe i hånden, og da kan du også
                være med når det skal skåles, men ingen trenger å få vite at det ikke er alkohol du drikker.`,
                },
                {
                title:'Bestem rammene',
                text:`
                En del situasjoner og følelsesmessige tilstander trigger et større alkoholinntak. Demp
                drikkingen ved å bestemme deg for når du ikke skal drikke. For eksempel:
                “Jeg kan drikke når jeg er glad og blant venner. Jeg skal ikke drikke når jeg er trist, stresset
                eller ensom.”`,
                },
        ]
    },
    { // 1 tab15 risiko3
        color: 'red',
        title: 'Slik kan du drikke sjeldnere:',
        data: [
            {
                title:'Planlegg uken din',
                text:`
                Ha en plan som kan måles i glass per uke. Hvor mange glass kan du drikke? Hvilke dager?
                Skriv det ned i kalenderen før uken begynner, og hold deg til denne planen.`,
                },
                {
                title:'Glem barskapet',
                text:`
                Gjør det litt mer tungvint for deg selv å drikke ved å ikke ha alkohol hjemme.
                Skal du ha folk på middag? Kjøp bare det som trengs – dropp den ekstra flasken som “kan
                komme godt med”. Ikke ha favorittdrikken din hjemme.`,
                },
                {
                title:'Finn på andre ting',
                text:`
                Finn på noe annet å gjøre noen kvelder i uken. Prøv en ny treningsform eller noe annet
                som krever litt tid og konsentrasjon. Vær sammen med venner som ikke trenger et glass
                vin eller en øl som påskudd for å møtes.
                Gjør nye ting som du synes er skikkelig morsomme. Da føles det i mindre grad som at du
                ikke får lov til å drikke, men mer som at du får anledning til å gjøre noe annet.`,
                },
                {
                title:'Ikke si “nja …”',
                text:`
                Forskning viser at det har god effekt å begynne setningen med et nei når du vil avstå fra alkohol.
                Når du er tydelig fra starten av, er risikoen for å vakle mindre, og den som spør, får mindre rom for
                å prøve å overtale deg.
                “Nei, jeg står over. Hvordan går det med fotballen, spilte ikke dere kamp forrige uke?”`,
                },
                {
                title:'Jug i vei!',
                text:`
                Selv om du prøver å redusere alkoholinntaket, er det ikke sikkert at du har lyst til å snakke
                om det hele tiden. Med noe alkoholfritt i glasset skiller du deg ikke ut, og forhåpentligvis
                unngår du diskusjoner og mas. Det kan være godt å ha noe i hånden, og da kan du også
                være med når det skal skåles, men ingen trenger å få vite at det ikke er alkohol du drikker.`,
                },
                {
                title:'Bestem rammene',
                text:`
                En del situasjoner og følelsesmessige tilstander trigger et større alkoholinntak. Demp
                drikkingen ved å bestemme deg for når du ikke skal drikke. For eksempel:
                “Jeg kan drikke når jeg er glad og blant venner. Jeg skal ikke drikke når jeg er trist, stresset
                eller ensom.”`,
                },
        ]
    },
    { // 1 tab16 risiko4
        color: 'red',
        title: 'Slik kan du drikke sjeldnere:',
        data: [
            {
                title:'Ta en pause',
                text:`
                Å faktisk bestemme seg for å ikke drikke overhode en periode kan være lurt for å stoppe
                opp og reflektere. Hvordan påvirker alkoholen deg og livet ditt? Du kommer kanskje til å
                merke at du får det bedre på noen måter, samtidig som andre situasjoner kan oppleves
                vanskeligere.
                Hvis du ønsker å ta en pause fra drikkingen en stund er det bra å unngå helt de
                situasjonene som er knyttet til alkohol. Hvis du bare lever akkurat som vanlig er det mest
                sannsynlig at også drikkevanene dine blir som før.`,
                },
                {
                title:'Unngå risikosituasjoner',
                text:`
                Hvordan vi oppfører oss avhenger av situasjonen. Det gjelder ikke minst dersom du prøver
                å justere ned på alkoholen.
                Vil du drikke mindre er det lurt å unngå situasjoner der det er vanskelig å takke nei. Det
                kan være en person du alltid pleier å ta et glass med eller en situasjon der alkohol er en
                selvsagt del og som du trenger å unngå en periode.
                Bestem hvilke situasjoner som fungerer og hvilke du trenger å unngå for å klare å drikke
                mindre. Hold deg til planen din.`,
                },
                {
                title:'Sulten eller tørst?',
                text:`
                Trenger du en skive eller en øl? Signalene du får fra kroppen når du er sulten kan lett
                tolkes som at du har lyst på alkohol.
                Prøv å ta deg noe å spise i stedet for å drikke. For mange minsker alkoholsuget, eller til og
                med forsvinner helt.`,
                },
            {
                title:'Planlegg uken din',
                text:`
                Ha en plan som kan måles i glass per uke. Hvor mange glass kan du drikke? Hvilke dager?
                Skriv det ned i kalenderen før uken begynner, og hold deg til denne planen.`,
                },
                {
                title:'Glem barskapet',
                text:`
                Gjør det litt mer tungvint for deg selv å drikke ved å ikke ha alkohol hjemme.
                Skal du ha folk på middag? Kjøp bare det som trengs – dropp den ekstra flasken som “kan
                komme godt med”. Ikke ha favorittdrikken din hjemme.`,
                },
                {
                title:'Finn på andre ting',
                text:`
                Finn på noe annet å gjøre noen kvelder i uken. Prøv en ny treningsform eller noe annet
                som krever litt tid og konsentrasjon. Vær sammen med venner som ikke trenger et glass
                vin eller en øl som påskudd for å møtes.
                Gjør nye ting som du synes er skikkelig morsomme. Da føles det i mindre grad som at du
                ikke får lov til å drikke, men mer som at du får anledning til å gjøre noe annet.`,
                },
                {
                title:'Ikke si “nja …”',
                text:`
                Forskning viser at det har god effekt å begynne setningen med et nei når du vil avstå fra alkohol.
                Når du er tydelig fra starten av, er risikoen for å vakle mindre, og den som spør, får mindre rom for
                å prøve å overtale deg.
                “Nei, jeg står over. Hvordan går det med fotballen, spilte ikke dere kamp forrige uke?”`,
                },
                {
                title:'Jug i vei!',
                text:`
                Selv om du prøver å redusere alkoholinntaket, er det ikke sikkert at du har lyst til å snakke
                om det hele tiden. Med noe alkoholfritt i glasset skiller du deg ikke ut, og forhåpentligvis
                unngår du diskusjoner og mas. Det kan være godt å ha noe i hånden, og da kan du også
                være med når det skal skåles, men ingen trenger å få vite at det ikke er alkohol du drikker.`,
                },
                {
                title:'Bestem rammene',
                text:`
                En del situasjoner og følelsesmessige tilstander trigger et større alkoholinntak. Demp
                drikkingen ved å bestemme deg for når du ikke skal drikke. For eksempel:
                “Jeg kan drikke når jeg er glad og blant venner. Jeg skal ikke drikke når jeg er trist, stresset
                eller ensom.”`,
                },
        ]
    },
    { // 1 tab17 risiko5
        color: 'red',
        title: 'Slik kan du drikke sjeldnere:',
        data: [
            {
                title:'Hvordan føles suget?',
                text:`
                Tenk deg at alkoholsuget er som en bølge. Først øker og øker den, før den dabber av. Å
                «surfe på alkoholsuget” er en metode som handler om å stå stødig i alkoholsuget, kjenne
                etter hvordan det føles, men la være med å belønne suget med alkohol. Alkoholsuget
                kommer til å dabbe av etter en stund og du har klart å håndtere det uten å drikke.
                Det er bra å lære seg å kjenne suget og øve på å håndtere det uten å og etter. Metoden vil
                etter hvert føre til at suget minsker i styrke og dukker opp sjeldnere.`,
                },
                {
                title:'Be om hjelp fra venner',
                text:`
                Å få støtte av noen som du stoler på kan være til stor hjelp. Fortell at du prøver å drikke
                mindre, og be om hjelp.
                Spør om kompisen eller venninnen din kan hjelpe deg ved å finne på ting dere kan gjøre
                sammen som ikke inkluderer alkohol. Eller be om støtte i sosiale situasjoner der det er
                forventning om at det skal drikkes`,
                },
                {
                title:'Utsett avgjørelsen',
                text:`
                Å utsette ta avgjørelsen om å drikke i ti minutter kan ofte være nok for å få alkoholsuget
                til å forsvinne, slik at du skal klare å stå imot. Det mest påtrengende suget tar gjerne ikke
                lengre enn det for å dempe seg.
                Det kan også hjelpe å utsette avgjørelsen enda lenge. Tenk at “Nå skal vi spise. Etter at jeg
                har spist kan jeg ta avgjørelsen på om jeg skal drikke i kveld eller ikke.”
                Ofte kjennes det mindre dramatisk å ta beslutningen i små omganger, som kan gi et bra
                resultat.`,
                },
                {
                title:'Ta en pause',
                text:`
                Å faktisk bestemme seg for å ikke drikke overhode en periode kan være lurt for å stoppe
                opp og reflektere. Hvordan påvirker alkoholen deg og livet ditt? Du kommer kanskje til å
                merke at du får det bedre på noen måter, samtidig som andre situasjoner kan oppleves
                vanskeligere.
                Hvis du ønsker å ta en pause fra drikkingen en stund er det bra å unngå helt de
                situasjonene som er knyttet til alkohol. Hvis du bare lever akkurat som vanlig er det mest
                sannsynlig at også drikkevanene dine blir som før.`,
                },
                {
                title:'Unngå risikosituasjoner',
                text:`
                Hvordan vi oppfører oss avhenger av situasjonen. Det gjelder ikke minst dersom du prøver
                å justere ned på alkoholen.
                Vil du drikke mindre er det lurt å unngå situasjoner der det er vanskelig å takke nei. Det
                kan være en person du alltid pleier å ta et glass med eller en situasjon der alkohol er en
                selvsagt del og som du trenger å unngå en periode.
                Bestem hvilke situasjoner som fungerer og hvilke du trenger å unngå for å klare å drikke
                mindre. Hold deg til planen din.`,
                },
                {
                title:'Sulten eller tørst?',
                text:`
                Trenger du en skive eller en øl? Signalene du får fra kroppen når du er sulten kan lett
                tolkes som at du har lyst på alkohol.
                Prøv å ta deg noe å spise i stedet for å drikke. For mange minsker alkoholsuget, eller til og
                med forsvinner helt.`,
                },
               
            {
                title:'Planlegg uken din',
                text:`
                Ha en plan som kan måles i glass per uke. Hvor mange glass kan du drikke? Hvilke dager?
                Skriv det ned i kalenderen før uken begynner, og hold deg til denne planen.`,
                },
                {
                title:'Glem barskapet',
                text:`
                Gjør det litt mer tungvint for deg selv å drikke ved å ikke ha alkohol hjemme.
                Skal du ha folk på middag? Kjøp bare det som trengs – dropp den ekstra flasken som “kan
                komme godt med”. Ikke ha favorittdrikken din hjemme.`,
                },
                {
                title:'Finn på andre ting',
                text:`
                Finn på noe annet å gjøre noen kvelder i uken. Prøv en ny treningsform eller noe annet
                som krever litt tid og konsentrasjon. Vær sammen med venner som ikke trenger et glass
                vin eller en øl som påskudd for å møtes.
                Gjør nye ting som du synes er skikkelig morsomme. Da føles det i mindre grad som at du
                ikke får lov til å drikke, men mer som at du får anledning til å gjøre noe annet.`,
                },
                {
                title:'Ikke si “nja …”',
                text:`
                Forskning viser at det har god effekt å begynne setningen med et nei når du vil avstå fra alkohol.
                Når du er tydelig fra starten av, er risikoen for å vakle mindre, og den som spør, får mindre rom for
                å prøve å overtale deg.
                “Nei, jeg står over. Hvordan går det med fotballen, spilte ikke dere kamp forrige uke?”`,
                },
                {
                title:'Jug i vei!',
                text:`
                Selv om du prøver å redusere alkoholinntaket, er det ikke sikkert at du har lyst til å snakke
                om det hele tiden. Med noe alkoholfritt i glasset skiller du deg ikke ut, og forhåpentligvis
                unngår du diskusjoner og mas. Det kan være godt å ha noe i hånden, og da kan du også
                være med når det skal skåles, men ingen trenger å få vite at det ikke er alkohol du drikker.`,
                },
                {
                title:'Bestem rammene',
                text:`
                En del situasjoner og følelsesmessige tilstander trigger et større alkoholinntak. Demp
                drikkingen ved å bestemme deg for når du ikke skal drikke. For eksempel:
                “Jeg kan drikke når jeg er glad og blant venner. Jeg skal ikke drikke når jeg er trist, stresset
                eller ensom.”`,
                },
        ]
    }

];

export default tables;